import React from 'react';
import { NewOrderForm } from '../components/orders/NewOrderForm';

const NewOrderPage = () => {
  return <NewOrderForm />;
};

export default NewOrderPage;
